import { StyleSheet } from 'react-native';

import { whiteTransparent } from 'utils/colors';
import { isTabletOrWeb } from 'utils/responsiveness';

const styles = StyleSheet.create({
    tabletButtonIndent: {
        marginRight: 12,
    },
    button: {
        marginTop: isTabletOrWeb ? 0 : 12,
    },
    borderedButton: {
        borderWidth: isTabletOrWeb ? 2 : 1.5,
        borderColor: isTabletOrWeb
            ? whiteTransparent(0.3)
            : whiteTransparent(0.7),
    },
});

export default styles;
